import api from '../axios'


export default {
  login: (payload) => api.post('customer/login', payload),
  // logout: () => api.get('/staff/logout'),
  getCurrentUser: () => api.get('/customer/get-current'),
  getPermissions: () => api.get('/customer/get-current-permissions'),
  verify2FA: (payload, staff_id) => api.put(`/customer/2fa/${staff_id}/validate-2fa`, payload),
}
